export const editOktaUser = ({
  token,
  profile,
  revokeAccess,
  grantAccess,
  revokeAgencies,
  grantAgencies,
  userId,
}) => ({
  HTTPMethod: "patch",
  path: `/api/v1/sso/users/${userId}`,
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  body: {
    data: {
      profile,
      revoke_agencies: revokeAgencies,
      grant_agencies: grantAgencies,
      revoke_access: revokeAccess,
      grant_access: grantAccess,
    },
  },
});
